import { NgModule } from '@angular/core';
import { Camera, Check, Heart, PlusCircle, Settings, Plus, Minus, MinusCircle, ArrowLeft, ArrowRight, ArrowUp, ArrowDown, OvsuiteIconsModule } from '@ov-suite/styles';

// select icons to include
const icons = {
  Camera,
  Check,
  Heart,
  MinusCircle,
  PlusCircle,
  ArrowLeft,
  ArrowRight,
  Plus,
  Minus,
  Settings,
  ArrowUp,
  ArrowDown,
};

@NgModule({
  imports: [OvsuiteIconsModule.pick(icons)],
  exports: [OvsuiteIconsModule],
})
export class UiIconsModule {}
